import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { LoadingBarService } from '@ngx-loading-bar/core';

import {
  HeaderService,
  ServiceOrderManagementService
} from '../../../shared';

@Component({
  selector: 'app-service-order-management-list',
  templateUrl: './service-order-management-list.component.html',
  styleUrls: ['./service-order-management-list.component.scss']
})
export class ServiceOrderManagementListComponent implements OnInit {
  typeComponent = "service-order-management";

  textBtnNew = "Nova ordem de serviço";
  urlBtnNew = "/panel/service-order/new";

  currentUrl = "/panel/service-order-management";

  dataList;

  pag;
  filters;
  cacheObj;

  serviceRequest;

  totalServiceOrderManagement;

  constructor(
    private headerService: HeaderService,
    private serviceOrderManagementService: ServiceOrderManagementService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle('Aprovar ou reprovar ordem de serviço');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  serviceOrderManagementList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if(this.serviceRequest) {
      this.serviceRequest.unsubscribe();
    }

    this.serviceRequest = this.serviceOrderManagementService.listServicesOrdersManagement(filters).subscribe((response) => {
      this.loadingBarService.complete();

      this.dataList = response;

      this.totalServiceOrderManagement = response['total'];
    });
  }

  setPag(setPag) {
    this.pag = setPag;

    this.translateFilter();
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.serviceOrderManagementList(`?pageNumber=${this.pag}&`+this.filters.join('&'));
  }

}
